import { defineComponent, onMounted, onUnmounted } from '@vue/composition-api';
import { Btn } from '@/components/Button';
import { Icon, IconSize } from '@/components/Icon';
import { mdiClose } from '@mdi/js';
export default defineComponent({
    components: { Icon, Btn },
    props: {
        value: {
            type: Boolean,
            default: true,
        },
        closeButton: {
            type: Boolean,
            default: false,
        },
        closeButtonClass: {
            type: String,
            default: '',
        },
    },
    setup(props, ctx) {
        const closeModal = () => {
            ctx.emit('input', false);
        };
        const handleKeydown = (event) => {
            if (event.key === 'Escape' && props.value) {
                closeModal();
            }
        };
        onMounted(() => {
            document.addEventListener('keydown', handleKeydown);
        });
        onUnmounted(() => {
            document.removeEventListener('keydown', handleKeydown);
        });
        return {
            mdiClose,
            IconSize,
            closeModal,
        };
    },
});
